import React, { Component } from 'react';
import { Label, Button, RichTextInput, FileUpload, Switch } from 'app/components/Basics';
import {QuestionFormContext} from '../../QuestionContext'
import { Select } from '@ecosystem/ui-lib/core/components/Select';
import { Card } from '@ecosystem/ui-lib/core/components/Card';
import { ButtonIcon } from '@ecosystem/ui-lib/core/components/ButtonIcon';
import { Icons } from '@ecosystem/ui-lib/core/components/Icon';
import { Checkbox } from '@ecosystem/ui-lib/core/components/Checkbox';
import { Input as EcoInput } from '@ecosystem/ui-lib/core/components/Input';
import { GenericCell } from '@ecosystem/ui-lib/core/components/Table';
import { ReactComponent as PlusIcon } from 'app/assets/icons/Plus.svg';
import TableDraggableRows from 'app/components/TableDraggableRows'
import NewQuestion from '../../QuestionModel';
import { Constants } from '../../../../constants/constants'
import { GetLanguageTexts, addMissingLanguageTexts } from '../../QuestionTextHelper';
import './TabGridComponent.scss';

class TabGrid extends Component {

	GridIsRandomOptions = [
        {value:1, label: "Random"},
        {value:0, label: "Ascending"}        
    ]

    constructor(props){
        super(props);
        this.state = {
            showInstructions: false
        };

    }

    componentDidMount() {
        this.syncInstructionsVisibility();
    }

    componentDidUpdate() {
        this.syncInstructionsVisibility();
    }

    syncInstructionsVisibility() {
        if (this.hasAnyInstructionData() && !this.state.showInstructions) {
            this.setState({ showInstructions: true });
        }
    }

    hasAnyInstructionData() {
        const statements = (this.context.selectedQuestion && this.context.selectedQuestion.groupStatements) || [];
        return statements.some(q => (q.texts || []).some(t => t.introduction && t.introduction.trim() !== ''));
    }

    isInstructionsVisible() {
        return this.state.showInstructions;
    }

    isInstructionsToggleDisabled() {
        return !this.context.canChangeData || this.hasAnyInstructionData();
    }

    handleInstructionsToggle(value) {
        this.setState({ showInstructions: value });
    }

	getTableHeaders() {		
		return [
			{
				id: 'column-grid-code',
				label: 'Code'
			},			
			{
				id: 'column-grid-question-text',
				label: 'Question'
			},			
			{
				id: 'column-grid-remove',
				label: 'Remove'
			}
		];
	}

	getDraggableRows() {
		const draggableRows = [];		
        this.context.selectedQuestion.groupStatements.forEach((question) => {            
			draggableRows.push(this.getDraggableRowCells(question));			
        });
		return draggableRows;
	}

	getDraggableRowCells(question) {
		var draggableRow = {};
		draggableRow.itemId = question._frontEndQuestionId;
		draggableRow.item = question;
		draggableRow.cells = this.getCells(question);
		return draggableRow;
	}

	getCells(question) {		
        const cols = [];
        cols.push(<GenericCell className="column-code" primary={<EcoInput  	
		disabled={!this.context.canChangeData}	
		value={question.code} 
		onChange={this.statementCodeHandler(question._frontEndQuestionId)}
		key={question._frontEndQuestionId}
		id={question._frontEndQuestionId}
		error={this.getEmptyStatementCodeValidationError(question)}
		></EcoInput>}/>);        
		cols.push(<GenericCell className="column-question-text" primary={
            <>
                <RichTextInput 
                key={question._frontEndQuestionId}		
                id={question._frontEndQuestionId}
                disabled={!this.context.canChangeData}
                value={GetLanguageTexts(question.texts, this.context.selectedLanguageCode).text}			      
                onValueChange={this.statementTextHandler.bind(this)}            
                ctrlsPosition="right" 
                maxLines={2}
                error={this.getEmptyStatementTextValidationError()} />

                {this.isInstructionsVisible() &&
                <div className="statement-instructions-section">
                    <div className="statement-instructions-header">
                        <Label>Instructions</Label>
                    </div>
                    <RichTextInput
                        key={`instr_${question._frontEndQuestionId}`}
                        id={question._frontEndQuestionId}
                        disabled={!this.context.canChangeData}
                        value={GetLanguageTexts(question.texts, this.context.selectedLanguageCode).introduction}
                        onValueChange={this.statementInstructionsHandler.bind(this)}
                        ctrlsPosition="right"
                        maxLines={2} />
                    <div className="statement-allow-hiding-option">
                        <Checkbox
                            disabled={!this.context.canChangeData}
                            checked={question.isCollapsibleIntro === true}
                            onChange={this.statementIsCollapsibleIntroHandler(question._frontEndQuestionId)}
                        />
                        <Label>Collapsible</Label>
                    </div>
                </div>}
            </>
        }/>);       
        cols.push(<GenericCell className="column-remove" primary={<div><ButtonIcon isDisabled={!this.context.canChangeData} onClick={() => this.removeQuestionHandler(question._frontEndQuestionId)}  icon={Icons.Close}/></div>}/>);        
        return cols;
    }

	statementCodeHandler = questionId => (event) => {
		var selectedQuestion = this.context.selectedQuestion;
		let statement = selectedQuestion.groupStatements.find(g=>g._frontEndQuestionId === questionId);
		statement.code = event.target.value;
		this.context.updateSelectedQuestion(selectedQuestion);
    }
	
	statementTextHandler(newText, richTextInputId) {
		var selectedQuestion = this.context.selectedQuestion;
		let statement = selectedQuestion.groupStatements.find(g=>g._frontEndQuestionId === richTextInputId);
		GetLanguageTexts(statement.texts, this.context.selectedLanguageCode).text = newText;
        this.context.updateSelectedQuestion(this.context.selectedQuestion);
    }

	statementInstructionsHandler(newText, richTextInputId) {
		var selectedQuestion = this.context.selectedQuestion;
		let statement = selectedQuestion.groupStatements.find(g=>g._frontEndQuestionId === richTextInputId);
		GetLanguageTexts(statement.texts, this.context.selectedLanguageCode).introduction = newText;
        this.context.updateSelectedQuestion(this.context.selectedQuestion);
    }

	statementIsCollapsibleIntroHandler = questionId => (event) => {
		var selectedQuestion = this.context.selectedQuestion;
		let statement = selectedQuestion.groupStatements.find(g=>g._frontEndQuestionId === questionId);
		statement.isCollapsibleIntro = event.target.checked;
		this.context.updateSelectedQuestion(selectedQuestion);
    }

	getEmptyStatementTextValidationError() {
		let validationError = this.props.errors.find(e => e.field.startsWith('gridQuestion_text'));
		return validationError != null ? validationError.errorMessage : "";		
	}
	
	getEmptyStatementCodeValidationError(question) {
		if (this.props.hasError && question.code === '') {
			return "question code is empty"
		}
		else {
			return "";
		}
	}

	removeQuestionHandler(questionId) {
		var selectedQuestion = this.context.selectedQuestion;		
        if (selectedQuestion.groupStatements) {
			selectedQuestion.groupStatements = selectedQuestion.groupStatements.filter(function(f) { return f._frontEndQuestionId !== questionId });
            this.context.updateSelectedQuestion(selectedQuestion);
        }
	}

	validateNewOrderedList() {
		return true;
	}	

	updateNewOrderedQuestionList(newOrderedList) {
		var selectedQuestion = this.context.selectedQuestion;
		selectedQuestion.groupStatements = newOrderedList;
		this.context.updateSelectedQuestion(selectedQuestion);		
	}	

	addStatement() {		
		var selectedQuestion = this.context.selectedQuestion;
		if (selectedQuestion._frontEndQuestionId == null) {
			selectedQuestion._frontEndQuestionId = Constants.TEMP_ID_PLACEHOLDER + "_new_parent_" + Date.now();
		}		
		const newQuestion = NewQuestion(this.context.defaultLanguageCode);
		newQuestion.questionType = this.context.gridSubType || 'SS';
		addMissingLanguageTexts(newQuestion, this.context.selectedLanguageCode, this.context.updateSelectedQuestion.bind(this));		
		newQuestion._frontEndQuestionId = Constants.TEMP_ID_PLACEHOLDER + Date.now();
		newQuestion.groupQuestionId = selectedQuestion._frontEndQuestionId;
		selectedQuestion.groupStatements.push(newQuestion);		
		this.context.updateSelectedQuestion(selectedQuestion);
	}

	getSelectedGridOrder() {        
        return this.GridIsRandomOptions.find(t=> t.value === this.context.selectedQuestion.randomizeGridQuestions)
    }

	changeGridQuestionOrder(gridOrder) {		
		var selectedQuestion = this.context.selectedQuestion;
		selectedQuestion.randomizeGridQuestions = gridOrder.value;
		this.context.updateSelectedQuestion(selectedQuestion);		
	}	

    render() {
		const draggableRows = this.getDraggableRows();		
        return (
			<div className="TabGridComponent content-box">
				<Card>
					<div className="form-row">
						<div className="form-row-left">
							<div className="field-option-order">
								<Label>Order</Label>
								<Select name="gridSortOrder" isDisabled={!this.context.canChangeData} 
									isSearchable={false}
									defaultValue={{value:1, label: "Random"}}
									value={this.getSelectedGridOrder()}
									options={this.GridIsRandomOptions}
									onChange={val=>{
										this.changeGridQuestionOrder(val)                                
									}}/>
							</div>
							<div className="field-option-instructions">
								<Label>Instructions</Label>
								<Switch
									name="showInstructionsToggle"
									checked={this.isInstructionsVisible()}
									disabled={this.isInstructionsToggleDisabled()}
									setSwitchValue={val => this.handleInstructionsToggle(val)}
								/>
							</div>
						</div>
						<div className="form-row-right">
							<Button disabled={!this.context.canChangeData} secondary icon={<PlusIcon/>} onClick={() => this.addStatement()}>Statement</Button>
						</div>
					</div>
					
					<div style={{display: draggableRows.length === 0 ? 'none' : 'block' }}>
					<TableDraggableRows 
						disabled={!this.context.canChangeData} 
						tableHeaders={this.getTableHeaders()} 
						tableRows={draggableRows}
						validateNewOrderedList={this.validateNewOrderedList.bind(this)}
						updateNewOrderedList={this.updateNewOrderedQuestionList.bind(this)}
						>						
					</TableDraggableRows>
					</div>

					<div style={{display: draggableRows && draggableRows.length > 0 ? 'none' : 'block' }}>
						<p className='EmptyQuestionListInfoTitle'>Statement list is empty</p>
						<p className='EmptyQuestionListInfoText'>Please, add statements via <span className='span-box'>+Statement</span></p>
					</div>
				</Card>
			</div>
        );
    }
}
TabGrid.contextType = QuestionFormContext;
export default TabGrid;
